module.exports = __webpack_public_path__ + "static/media/cart.34ddd736.svg";